import { CheckCircle2, Lock } from "lucide-react";
import { fmtMoney } from "../lib/format";

// Driver pricing options (server-authoritative): every Host-configured plan
// type is rendered as a card; unavailable options stay visible but disabled,
// with the server's reason. The client never computes prices — parking_cents
// come verbatim from the quote engine (the same engine that builds the
// PaymentIntent, so the displayed price always equals the charged price).
export default function RateOptions({ options, selected, onSelect, currency, busy }) {
  if (!options?.length) return null;
  return (
    <div data-testid="rate-options">
      <p className="meta-label mb-2.5">Pricing options</p>
      <div className="space-y-2" role="radiogroup" aria-label="Pricing options">
        {options.map((o) => {
          const unavailable = !o.available || !o.applicable;
          const disabled = unavailable || busy;
          const active = selected === o.mode && !unavailable;
          return (
            <button key={o.mode} type="button" role="radio" aria-checked={active} aria-disabled={disabled}
                    data-testid={`pricing-mode-${o.mode}`}
                    disabled={disabled}
                    onClick={() => onSelect(o.mode)}
                    className={`w-full text-left rounded-xl border px-4 py-3.5 transition-all duration-200 backdrop-blur-sm ${
                      active
                        ? "border-[#E50914] bg-[#E50914]/10 shadow-lg shadow-[#E50914]/10"
                        : unavailable
                          ? "border-[#1F2328] bg-[#0A0D10]/60 opacity-60 cursor-not-allowed"
                          : "border-[#27272A] bg-[#0A0D10] hover:border-[#3F3F46] hover:bg-white/[0.03]"}`}>
              <span className="flex items-center justify-between gap-3">
                <span className={`text-sm font-bold ${active ? "text-white" : "text-zinc-300"}`}>{o.label}</span>
                {o.parking_cents != null && (
                  <span className={`font-display font-bold ${active ? "text-white" : "text-zinc-200"}`} data-testid={`rate-option-${o.mode}-price`}>
                    {fmtMoney(o.parking_cents / 100, currency)}
                  </span>
                )}
              </span>
              {o.detail && <span className="block mt-1 text-[11px] text-zinc-500">{o.detail}</span>}
              {unavailable ? (
                <span className="mt-1.5 flex items-center gap-1.5 text-[11px] text-amber-400/90" data-testid={`rate-option-${o.mode}-reason`}>
                  <Lock className="w-3 h-3 shrink-0" /> {o.reason}
                </span>
              ) : active ? (
                <span className="mt-1.5 flex items-center gap-1.5 text-[11px] text-[#FF3B45]" data-testid={`rate-option-${o.mode}-selected`}>
                  <CheckCircle2 className="w-3 h-3" /> Selected
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
